import React, {useContext} from "react";
import {CreateDeliveryContext} from "../CreateDeliveryRequest";
import {useTranslation} from "react-i18next";
import {
    FormHeader,
    CustomerFormHeader,
    SubmitDeliveryButton,
    CustomerSubmitDeliveryButton,
    CustomerButtonContainer,
    FormContainer,
    CustomerFormContainer,
    DeliveryRequestTabs
} from "./DeliveryRequestForm.styles";
import {PickupInformation} from "./pickupInformation/PickupInformation";
import {OrderInformation} from "./orderInformation/OrderInformation";
import {CustomButton} from "components/_defaultComponents/CustomButton/CustomButton";
import {PlusOutlined} from "@ant-design/icons";
import {Tabs} from "antd";
import {useStore} from "@vigo/hooks";

const {TabPane} = Tabs;

export const DeliveryRequestForm = () => {
    const {t} = useTranslation(["newRequest"]);
    const stores = useStore();
    const {submitDelivery, isFromCustomerTheme, addOrder} = useContext(CreateDeliveryContext);
    // Choose styles based on customer theme
    const FormContainerComponent = isFromCustomerTheme ? CustomerFormContainer : FormContainer;
    const FormHeaderComponent = isFromCustomerTheme ? CustomerFormHeader : FormHeader;
    const SubmitButtonComponent = isFromCustomerTheme
        ? CustomerSubmitDeliveryButton
        : SubmitDeliveryButton;

    return (
        <>
            <FormContainerComponent>
                {isFromCustomerTheme ? (
                    ""
                ) : (
                    <FormHeaderComponent>
                        {t("screens.newRequest", {ns: "common"})}
                    </FormHeaderComponent>
                )}
                {isFromCustomerTheme ? (
                    <DeliveryRequestTabs>
                        <Tabs
                            defaultActiveKey="order"
                            style={{
                                width: "100%",
                                marginBottom: "20px"
                            }}
                            size="large"
                            className="delivery-request-tabs"
                        >
                            <TabPane tab="Gönderici Bilgileri" key="pickup">
                                <PickupInformation />
                            </TabPane>
                            <TabPane tab="Sipariş Bilgileri" key="order">
                                <OrderInformation />
                                <CustomerButtonContainer>
                                    <CustomButton
                                        data-testid="addOrderButton"
                                        onClick={() => addOrder && addOrder()}
                                        icon={<PlusOutlined />}
                                        style={{width: "100%"}}
                                    >
                                        {t("newRequest.actions.addOrder", {
                                            ns: "newRequest"
                                        })}
                                    </CustomButton>
                                    <SubmitButtonComponent
                                        type="primary"
                                        onClick={() => submitDelivery()}
                                        style={{width: "100%"}}
                                    >
                                        {t("newRequest.actions.createDelivery", {ns: "newRequest"})}
                                    </SubmitButtonComponent>
                                </CustomerButtonContainer>
                            </TabPane>
                        </Tabs>
                    </DeliveryRequestTabs>
                ) : (
                    <>
                        <PickupInformation />
                        <OrderInformation />
                    </>
                )}
                {isFromCustomerTheme ||
                !stores.meStore.checkPermission("createDeliveryRequest.createOrder") ? (
                    <></>
                ) : (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "16px",
                            width: "100%"
                        }}
                    >
                        <CustomButton
                            data-testid="addOrderButton"
                            onClick={() => addOrder && addOrder()}
                            icon={<PlusOutlined />}
                        >
                            {t("newRequest.actions.addOrder", {
                                ns: "newRequest"
                            })}
                        </CustomButton>
                        <SubmitButtonComponent type="primary" onClick={() => submitDelivery()}>
                            {t("newRequest.actions.createDelivery", {ns: "newRequest"})}
                        </SubmitButtonComponent>
                    </div>
                )}
            </FormContainerComponent>
        </>
    );
};
